import type {
	BaseMetricDataWithStartAndStop,
	PerformanceEventConfig,
	ShareableGlobalConfig,
} from '../../types';

export const appFramework = (
	_config: PerformanceEventConfig,
	_data: BaseMetricDataWithStartAndStop,
	globalConfig: ShareableGlobalConfig,
): {
	'app:framework:name': string;
	'app:framework:version': string;
} | null => {
	if (!globalConfig.app.framework) {
		return null;
	}
	return {
		'app:framework:name': globalConfig.app.framework.name,
		'app:framework:version': globalConfig.app.framework.version,
	};
};
